// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	OfficeName: 'office-name',
	OfficeNickName: 'office-nick-name',
	HstRegistrationNumber: 'hst-registration-number',
	Fax: 'fax',
	WorkPhone: 'work-phone',
	CellPhone: 'cell-phone',
	Email: 'email',
	LocationSpecified: 'location-specified',
	RegionSpecified: 'region-specified',
	LocationSelect: 'location-select',
	RegionSelect: 'region-select',
	DeleteLogoButton: 'delete-logo-button',
	SaveButton: 'save-button',
	DefaultCommissionerOnMatterButtonSegmented:
		'default-commissioner-on-matter-button-segmented',
	DefaultWitnessOnMatterButtonSegmented:
		'default-witness-on-matter-button-segmented',
	Option: 'option',
	Option1: 'option-1',
	LogoDropzone: 'logo-dropzone',
} as const;
